import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_GALLERY_IMAGES,
  ADD_ITEM,
  ADD_VIDEO,
  CALCULATE_COMBO_PRICE,
  CLONE_ITEM,
  DELETE_ITEM,
  DELETE_MULTIPLE_ITEMS,
  ENABLE_DISABLE_ITEM,
  GET_ALL_ITEMS,
  GET_ALL_ITEMS_DROPDOWN,
  GET_ITEM_DETAILS,
  UPDATE_ITEM,
  UPDATE_ITEM_STATUS,
  UPDATE_MULTIPLE_ITEMS,
} from "helpers/url_helper"

export const getItemsList = createAsyncThunk(GET_ALL_ITEMS, async payload => {
  const response = await post(GET_ALL_ITEMS, payload)
  return response
})

export const updateItemStatus = createAsyncThunk(
  UPDATE_ITEM_STATUS,
  async payload => {
    const response = await patch(UPDATE_ITEM_STATUS, payload)
    return response
  }
)

export const addItem = createAsyncThunk(ADD_ITEM, async payload => {
  const response = await formDataPost(ADD_ITEM, payload)
  return response
})

export const getItemsDetails = createAsyncThunk(
  GET_ITEM_DETAILS,
  async payload => {
    const response = await post(GET_ITEM_DETAILS, payload)
    return response
  }
)

export const updateItem = createAsyncThunk(UPDATE_ITEM, async payload => {
  const response = await formDataPut(UPDATE_ITEM, payload)
  return response
})

export const deleteItem = createAsyncThunk(DELETE_ITEM, async payload => {
  const response = await del(DELETE_ITEM, payload)
  return response
})

export const getItemsListDropdown = createAsyncThunk(
  GET_ALL_ITEMS_DROPDOWN,
  async payload => {
    const response = await post(GET_ALL_ITEMS_DROPDOWN, payload)
    return response
  }
)

export const deleteMultipleItems = createAsyncThunk(
  DELETE_MULTIPLE_ITEMS,
  async payload => {
    const response = await del(DELETE_MULTIPLE_ITEMS, payload)
    return response
  }
)

export const updateMultipleItems = createAsyncThunk(
  UPDATE_MULTIPLE_ITEMS,

  async args => {
    const response = await put(UPDATE_MULTIPLE_ITEMS, args.payload)
    return response
  }
)

export const addGalleryImages = createAsyncThunk(
  ADD_GALLERY_IMAGES,
  async payload => {
    const response = await formDataPost(ADD_GALLERY_IMAGES, payload)
    return response
  }
)

export const addVideo = createAsyncThunk(ADD_VIDEO, async payload => {
  const response = await formDataPost(ADD_VIDEO, payload)
  return response
})

const REMOVE_VIDEO_URL_FROM_ITEM = "REMOVE_VIDEO_URL_FROM_ITEM"

export const removeVideoUrlFromItem = createAsyncThunk(
  REMOVE_VIDEO_URL_FROM_ITEM,
  async payload => {
    return REMOVE_VIDEO_URL_FROM_ITEM
  }
)

export const cloneItem = createAsyncThunk(CLONE_ITEM, async payload => {
  const response = await post(CLONE_ITEM, payload)
  return response
})

export const calculateComboPrice = createAsyncThunk(
  CALCULATE_COMBO_PRICE,
  async payload => {
    const response = await post(CALCULATE_COMBO_PRICE, payload)
    return response
  }
)

export const enableDisableItem = createAsyncThunk(
  ENABLE_DISABLE_ITEM,
  async payload => {
    const response = await patch(ENABLE_DISABLE_ITEM, payload)
    return response
  }
)
